export const openAiKey = "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";
